import React from "react";

interface ISignalRIssuesContext {
  sendRefetchTeamIssues: (teamSlug: string) => void;
  onShouldRefetchTeamIssues: (handler: (teamSlug: string) => void) => void;
  offShouldRefetchTeamIssues: (handler: (teamSlug: string) => void) => void;
  sendRefetchUserIssues: (userGuid: string) => void;
  onShouldRefetchUserIssues: (handler: (userGuid: string) => void) => void;
  offShouldRefetchUserIssues: (handler: (userGuid: string) => void) => void;
  sendRefetchIssue: (issueGuid: string) => void;
  onShouldRefetchIssue: (handler: (issueGuid: string) => void) => void;
  offShouldRefetchIssue: (handler: (issueGuid: string) => void) => void;
}

const SignalRIssuesContext = React.createContext<ISignalRIssuesContext>({
  sendRefetchTeamIssues: () => null,
  onShouldRefetchTeamIssues: () => null,
  offShouldRefetchTeamIssues: () => null,
  sendRefetchUserIssues: () => null,
  onShouldRefetchUserIssues: () => null,
  offShouldRefetchUserIssues: () => null,
  sendRefetchIssue: () => null,
  onShouldRefetchIssue: () => null,
  offShouldRefetchIssue: () => null,
});

export { SignalRIssuesContext };
